import type { FC } from 'react';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

const i18n = defineMessages({
	draftAccessWarningMessage: {
		id: 'share-and-restrict-dialog.principal-details-warning.draft-access-warning',
		defaultMessage: 'Needs “Can edit” to view this draft',
		description:
			'The warning message in the share and restrict dialog appears when the user does not Edit access to the draft.',
	},
});

export const DraftAccessWarning: FC = () => {
	return <FormattedMessage {...i18n.draftAccessWarningMessage} />;
};
